module.exports = __webpack_public_path__ + "assets/03ff9cb1c9e3ce45a7124890a7f27b8e.ttf";